'use client';

import { usePageTracking } from '@/hooks/useRUM';

/**
 * Component that automatically tracks page views for RUM analytics
 * Should be included in the root layout to track all route changes
 */
export const RUMPageTracker: React.FC = () => {
  // This hook automatically tracks page views when the route changes
  usePageTracking();

  // This component doesn't render anything visible
  return null;
}; 